<template>
  <div>
    <Nav />  
    <div class="pageWD shadowBox mT20">
      <div class="Knowledge"> 
         <el-row>
          <el-col :span="6" class="leftbar">         
          <el-input
          placeholder="请输入关键字"
          prefix-icon="el-icon-search"
          v-model="searchKey"
           @keyup.enter.native="tapSearch">
          </el-input>      
          <div style="background:#fff;padding-right:24px">
            <!-- <div @click="getAll">全部文档</div> -->
             <el-tree 
              ref="tree"
             :data="treelist"             
             :props="defaultProps" 
             node-key="fiId" 
             :current-node-key="currentNodeKey" 
             @node-click="handleNodeClick" 
             highlight-current 
             :expand-on-click-node="false" 
             :default-expand-all="defaultExpandAll" 
             icon-class="el-icon-caret-right" 
             :indent="indent"></el-tree>       
          </div>
          </el-col>
          <el-col :span="18">             
              <div class="mainTop c9 f14" v-if="searchEnter&&searchKey!=''">
                 搜索:{{searchKey}}
              </div>
               <div class="mainTop c9 f14" v-else >当前位置：
                 <!-- <span @click="getAll">全部文档</span>  -->
                <span v-if="breadList.length == '0'&&treelist.length!=0"> {{treelist[0].fiName}} </span>
                <span v-else v-for="(item,index) in breadList" :key="index" @click="tapBread(breadID[index])">  {{item}}
                  <span v-if="breadList.length!=index+1">></span> 
                </span>
              </div>
              <ul class="KList" v-if="fileList.length!=0"
                v-loading="loading"               
                element-loading-background="rgba(0, 0, 0, 0.1)"                
                >
                  <li v-for="(item,index) in fileList" :key="index" class="item">
                    <div v-if="item.fiType=='1'" class="folder">
                        <div class="normal" @mouseover="tapMouseOver(index)">
                            <div class="pic pic1"><img src="../../assets/images/folder.png" /></div>
                            <div class="name">{{item.fiName}}</div>
                            <div class="date">{{$conFun.parseData(item.fiCreatedon)}}</div>
                        </div>
                        <div class="over flex" :style="{display:(index==currentIndex?'':'none'),'animation-name':(index==currentIndex?'upMove':'')}" @click="openNext(item)"  @mouseleave="tapMouseLeave(index)">
                            <img src="../../assets/images/dakai_wj.png" />
                        </div>
                    </div>
                    <div v-else  class="otherfd">
                          <div class="normal" @mouseover="tapMouseOver(index)"  >
                            <div class="pic"  v-if="item.fiFiletype=='2'"><img src="../../assets/images/Know/docx.png" /></div>
                            <div class="pic"  v-if="item.fiFiletype=='1'"><img src="../../assets/images/Know/pdf.png" /></div>
                            <div class="pic"  v-if="item.fiFiletype=='4'"><img src="../../assets/images/Know/ppt.png" /></div>
                            <div class="pic"  v-if="item.fiFiletype=='3'"><img src="../../assets/images/Know/xlsx.png" /></div>
                            <div class="pic"  v-if="item.fiFiletype=='8'"><img src="../../assets/images/Know/txt.png" /></div>
                            <div class="pic"  v-if="item.fiFiletype=='7'"><img src="../../assets/images/Know/yinpin.png" /></div>
                            <div class="pic"  v-if="item.fiFiletype=='6'"><img src="../../assets/images/Know/shipin.png" /></div>
                            <div class="pic"  v-if="item.fiFiletype=='5'"><img src="../../assets/images/Know/tupian.png" /></div>
                            <div class="name">{{item.fiName}}</div>
                            <div class="date">{{$conFun.parseData(item.fiCreatedon)}}</div>
                          </div> 
                          <div class="over" :style="{'display':(index==currentIndex?'':'none'),'animation-name':(index==currentIndex?'upMove':'')}"  @mouseleave="tapMouseLeave(index)">
                               <div class="up"  @click="tapUp(item)"  :class="[index==currentIndex&&tapPos=='up'?'active':'']" @mouseover="tapMouseOverUp(index)" @mouseleave="tapMouseLeaveUp(index)">
                                  <span v-if="index==currentIndex&&tapPos=='up'">
                                    查看
                                  </span>
                                  <span v-else><img src="../../assets/images/chakan.png" /></span>
                               </div>
                               <div class="down"  @click="tapDown(item)" :class="[index==currentIndex&&tapPos=='down'?'active':'']"  @mouseover="tapMouseOverDown(index)" @mouseleave="tapMouseLeaveDown(index)">
                                  <span v-if="index==currentIndex&&tapPos=='down'">下载</span>
                                  <span v-else><img src="../../assets/images/xiazai.png" /></span>
                               </div>
                          </div>
                    </div>
                  </li>                 
              </ul>
              <div v-else class="noData">
                <Empty />                
              </div>
          </el-col>
        </el-row>
      </div>     
   </div> 
    <div style="height:20px"></div>   
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { getDocumentList ,getDocumentTree} from '@/api/api'
import Nav from "../../components/Nav.vue";
import BreadCrumb from "../../components/BreadCrumb.vue";
import Empty from "../../components/Empty.vue";
export default {
  components: { Nav , BreadCrumb , Empty}, 
   data() {
      return {
        loading: false,
        breadList:[],
        breadID:[],
        breadLabel:'',
        tapPos:'',      
        currentIndex:'-1',
        defaultExpandAll:true,
        indent:24,
        searchKey:'', 
        searchEnter:false,   
        treelist:[],
        currentNodeKey :null,
        defaultProps: {
          children: 'children',
          label: 'fiName'
        },        
        fileList:[]
      };
    },
    created() {     
      this.getDocList('0','1','')  
      this.getTree()
    },
    methods: {
      getTree(){
        var that = this
         var data = {
            coid: Cookies.get('qslCOID'),
            fiId:'0'
         } 
          getDocumentTree(data)
          .then(res => {            
            console.log(res.body.result)
            that.treelist = [
              {
                fiName:'全部文档',
                fiId:'0',
                children:res.body.result
              }
            ]
           
          })
          .catch(err => {});
      },
      openNext(item){      
        var that = this    
        if (item.fiType == '1') {          
           this.$nextTick(()=>{
             this.$refs.tree.setCurrentKey(item.fiId)
           })
           this.getDocList(item.fiId,'','');
          
        } 
        this.setBread(item.fiId)
      },  
      tapSearch(){        
         if(this.searchKey){           
            this.getDocList('-1','',this.searchKey)
         }else{           
            this.getAll()
         }  
          this.searchEnter = true       
      } , 
      getAll(){
        this.breadList = [];
        this.getDocList('0','','')
      } ,
      getDocList(parentId,isFirst,searchKey) {  
        var that = this     
        let data = {
          coid: Cookies.get('qslCOID'),
          memberId: Cookies.get('qslmemberId'),
          parentId: parentId,
          orderType: 3 ,
          key: searchKey
      };
      that.loading = true
      getDocumentList(data)
          .then(res => {           
            that.fileList = res.body.result.fileList;           
            that.currentIndex = '-1'
            that.loading = false
          })
          .catch(err => {});
	  	},
      tapMouseOverUp(index){
         this.tapPos = 'up'
      },
      tapMouseLeaveUp(index){
      },
      tapMouseOverDown(index){
        this.tapPos = 'down'
      },
      tapMouseLeaveDown(index){
      },
      tapMouseOver(index){       
         this.currentIndex = index
      },
      tapMouseLeave(){
         this.currentIndex = '-1'
      },
      tapBread(fiId){
        this.getDocList(fiId,'','')
        this.setBread(fiId)
        this.$nextTick(()=>{
          this.$refs.tree.setCurrentKey(fiId)
        })
      },
      handleNodeClick(data) {       
        this.getDocList(data.fiId,'','')
        this.setBread(data.fiId)
        this.searchKey = ''
        this.searchEnter = false
      },
      setBread(fiId){
        this.breadList = [];
        this.breadID=[] 
        this.getTreeNode(this.$refs.tree.getNode(fiId));
      },
      getTreeNode(node){
        if (node) {
          if (node.label !== undefined) {          
            this.breadList.unshift(node.label); //在数组头部添加元素
            this.getTreeNode(node.parent); //递归         
            this.breadID.push(node.data.fiId)
          }
        }
      },
      tapUp(item){      
        //Cookies.set("documentName",item.fiName);        
        let { href } = this.$router.resolve({ path: this.redirect || "/Knowledge/view?fiId=" + item.fiId +'&fiUrl='+item.fiUrl +'&fiFiletype='+item.fiFiletype})
        window.open(href, '_blank')
        //this.$router.push({ path: this.redirect || "/Knowledge/view?fiId=" + item.fiId +'&fiUrl='+item.fiUrl +'&fiFiletype='+item.fiFiletype})      
      },
      tapDown(item){         
          var filename = item.fiName;
          var xhr = new XMLHttpRequest();
          xhr.open('GET', item.fiUrl, true);
         // xhr.setRequestHeader("Content-Type", "application/json");
          xhr.responseType = 'blob';
          xhr.onload = function(res) {
            console.log(res)
                if (this.status === 200) {
                var type = xhr.getResponseHeader('Content-Type');
                var blob = new Blob([this.response], {type: type});
                      if (typeof window.navigator.msSaveBlob !== 'undefined') {
                          /*
                            * For IE
                            * >=IE10
                            */
                          window.navigator.msSaveBlob(blob, filename);
                      } else {
                          /*
                            * For Non-IE (chrome, firefox)
                            */
                          var URL = window.URL || window.webkitURL;
                          var objectUrl = URL.createObjectURL(blob);
                          if (filename) {
                              var a = document.createElement('a');
                              if (typeof a.download === 'undefined') {
                                  window.location = objectUrl;
                              } else {
                                  a.href = objectUrl;
                                  a.download = filename;
                                  document.body.appendChild(a);
                                  a.click();
                                  a.remove();
                              }
                          } else {
                              window.location = objectUrl;
                          }
                      }
                }
          }
          xhr.send();
      }
    }
  };
</script>
<style >
.Knowledge{
  min-height:853px 
}
.Knowledge .el-input__prefix{
  top:14px;
  left:25px
}
.Knowledge .el-input__inner{
  width: 250px;
  height: 40px;
  background: #f3f4f7;
  border-radius: 2px;
  border:0;
  margin:24px 0 0 24px
}
.Knowledge .el-tree-node__label {
  font-size:16px
}
.Knowledge .el-tree{
  color:#333;
  margin-top:22px;
}
.Knowledge .el-tree-node__content{
  height:58px
}
 /* .Knowledge .el-tree-node__content:nth-of-type(1){
  height:74px
}  */

.Knowledge .el-tree-node__expand-icon.is-leaf{
  color:default
}
 .Knowledge  .el-tree-node__label{
  background:url('../../assets/images/folder.png') no-repeat 2% center;
  background-size:24px;
  padding-left:32px;
  position:relative;
  left:0px
} 
 .Knowledge .el-tree-node__expand-icon{
  font-size:20px; padding:0
}
/* .Knowledge .el-tree-node__expand-icon.expanded
{
  transform: rotate(180deg);  position:relative;
} */
.Knowledge .el-tree-node__content>.el-tree-node__expand-icon{
 width:24px;
 height:20px;
 position:relative;
 left:0px;
 margin-right:4px;
 margin-left:20px
}
 .Knowledge .el-tree-node{
   white-space:normal
 }
.Knowledge .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
  background:url('../../assets/images/treebg.png') no-repeat  center;
  background-size:cover;
  color:#4B9AFB;
  z-index:100;
  position:relative;
  width:100%;
  transform:translated3d(0,0,0)
} 

/* .Knowledge .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content:first-child{
  background:url('../../assets/images/treebg.png') no-repeat  center;
  background-size:cover;
  color:#4B9AFB;
  z-index:100;
  position:relative;
  width:100%;
  transform:translated3d(0,0,0)
} */

/* .el-tree-node{
  margin:20px 0
} */

.KList{
  /* display: -webkit-flex;
  justify-content: space-between; 
  flex-wrap: wrap; */
  margin:24px;
  overflow: hidden;
}
.KList .item{
  width: 153px;
  height: 168px;  
  border-radius: 8px;
  text-align:center;
  margin-bottom:24px;
  position:relative;
  cursor: pointer;
  float:left
}
.KList .normal{
  position:absolute;
  left:0;
  right:0;
  bottom:0;
  width:100%;
  height:100%;
  background: #fff;
}
.KList .over{
  position:absolute;
  left:0;
  box-shadow:0px 1px 10px 0px rgba(0,0,0,0.10);
  right:0;
  bottom:0;
  width:100%;
  height:100%;
  animation-duration: 1s;
  border-radius: 8px;
  align-items: center;
  background: rgba(0,0,0,0.6);
  text-align:center
}
.KList .over img{
  margin:0 auto
}
.KList .date{
  color:#999;
  font-size:14px;
  padding-top:12px;
}
.KList .name{
  color:#333;
  font-size:14px;
  line-height: 18px;
  width:100px;
  height:36px;
  overflow:hidden;
   margin:0 auto
}
.KList .pic{  
   text-align:center;
   display:block;
   margin:0 auto;
   margin-top:24px
}
.KList .folder .pic img{
  width:48px;
  height:39px; 
}
.KList .otherfd .pic img{
  width:36px;
  height:48px; 
}
.KList .folder .name{
  margin-top:20px
}
.KList .otherfd .name{
  margin-top:14px
}
@keyframes upMove {
  from {top:5px;}
  to {top:0;}
}

.KList .item .up{
  position:absolute;
  left:0;  
  right:0;
  top:0;
  width:100%; 
  animation-duration: 1s;
  height:104px;
  line-height:104px;
  text-align:center;
  color:#fff;
  width:100%;
  border-top-left-radius:8px;
  border-top-right-radius:8px
}
.KList .item .down{
  position:absolute;
  left:0;  
  right:0;
  bottom:0;
  width:100%; 
  height:64px;
  line-height:64px;
  text-align:center;
  color:#fff;
  border-bottom-left-radius:8px;
  border-bottom-right-radius:8px
}

.KList .item .active{
  background: rgba(0,0,0,0.2);
}
.noData{
  margin: 24px;
  text-align: center;
  font-size: 18px;
  margin-top: 200px;
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/views/Knowledge/index.vue